import styled from 'styled-components';
import { typography } from '../../theme';
import { colors } from '../../theme/color';

export const InlineError = styled.div.attrs({
  'aria-live': 'polite',
})`
  ${typography.textStyle}
  color: ${colors.textError};
  margin: 8px 0;
  a {
    color: ${colors.textError};
  }
`;
